<template>
    <div>
        <template v-for="(item,index) in field">
            <b-badge :key="index" variant="dark" class="m-25">{{item.Vehicle}}</b-badge>
    
        </template>
    </div>
</template>

<script>
import {BBadge} from 'bootstrap-vue'
export default {
    components:{
        BBadge
    },
    props:{
        row:Object,
        field:[Object,String,Array,Number]
    }
}
</script>

<style>

</style>